import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { suitTestimonials } from '../../../mocks/trajesMedida';

export default function TestimonialsSection() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });

  return (
    <section ref={ref} className="w-full bg-brand-cream py-20 md:py-28">
      <div className="px-6 lg:px-[7%]">
        <div className="text-center max-w-2xl mx-auto" style={style}>
          <span className="font-sans text-brand-gray-400 text-[11px] tracking-[0.2em] uppercase font-medium">
            Testimonios
          </span>
          <h2 className="font-serif text-brand-black text-[clamp(2rem,4vw,3rem)] font-semibold leading-[1.15] mt-4">
            Lo que dicen
            <span className="italic text-brand-gray-300"> nuestros clientes</span>
          </h2>
        </div>

        <div className="mt-14 md:mt-16 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {suitTestimonials.map((t, index) => (
            <div
              key={t.id}
              className="bg-white rounded-3xl p-8 md:p-10 border border-transparent hover:border-brand-gray-100 transition-all duration-500 hover:-translate-y-1"
              style={isVisible ? {
                opacity: 1,
                transform: 'translateY(0px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 140}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 140}ms`,
              } : {
                opacity: 0,
                transform: 'translateY(36px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 140}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${200 + index * 140}ms`,
                willChange: 'opacity, transform',
              }}
            >
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>
              <p className="font-sans text-brand-gray-600 text-[15px] leading-[1.8] italic">
                "{t.text}"
              </p>
              <div className="mt-6 pt-6 border-t border-brand-gray-100">
                <p className="font-serif text-brand-black text-base font-medium">{t.name}</p>
                <p className="font-sans text-brand-gray-400 text-sm mt-0.5">{t.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}